import React, { useEffect, useState } from "react";
import axios from "axios";
import "./SocialComments.css";

const API_BASE = "https://atlastravelhouse.com";
const ENDPOINT = `${API_BASE}/api/social-comments/`;

function SocialComments() {
  const [comments, setComments] = useState([]);

  useEffect(() => {
    let mounted = true;

    const fetchComments = async () => {
      try {
        const res = await axios.get(ENDPOINT);
        if (mounted) setComments(res.data || []);
      } catch (err) {
        console.error("Failed to fetch social comments:", err);
      }
    };

    fetchComments();
    const poll = setInterval(fetchComments, 15000); 

    return () => {
      mounted = false;
      clearInterval(poll);
    };
  }, []);

  const resolveUrl = (src) => {
    if (!src) return "";
    if (src.startsWith("http") || src.startsWith("data:")) return src;
    return `${API_BASE.replace(/\/$/, "")}${src.startsWith("/") ? "" : "/"}${src}`;
  };

  if (!comments || comments.length === 0) return null;

  const mid = Math.ceil(comments.length / 2);
  const topList = comments.slice(0, mid).map((c) => resolveUrl(c.comment_image));
  const bottomList = comments.slice(mid).map((c) => resolveUrl(c.comment_image));

  const topDup = [...topList, ...topList];     
  const bottomDup = [...bottomList, ...bottomList];

  const base = 6;
  const perItem = 0.9;
  const topDuration = Math.max(base, Math.round(topList.length * perItem) + base);
  const bottomDuration = Math.max(base, Math.round(bottomList.length * perItem) + base + 3);

  return (
    <div className="social-comments-container">
      <h3 className="social-heading">
        What People Say About Us on Social Media
      </h3>

      <div className="customer-stories-wrapper">

        <div className="logo-strip">
          <div
            className="logo-track scroll-ltr"
            style={{ animationDuration: `${topDuration}s` }}
            aria-hidden="true"
          >
            {topDup.map((src, i) => (
              <img key={`top-${i}`} src={src} alt={`social-${i}`} loading="lazy" />
            ))}
          </div>
        </div>

        <div className="logo-strip">
          <div
            className="logo-track scroll-rtl"
            style={{ animationDuration: `${bottomDuration}s` }}
            aria-hidden="true"
          >
            {bottomDup.map((src, i) => (
              <img key={`bottom-${i}`} src={src} alt={`social-${i}`} loading="lazy" />
            ))}
          </div>
        </div>

      </div>
    </div>
  );
}

export default SocialComments;
